import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=73a6a34c"
import script from "./Metadata.vue?vue&type=script&lang=ts"
export * from "./Metadata.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports